document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mobile-menu-toggle]');
  if (!trigger) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.hasAttribute('hidden');
  if (open) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', '');
  trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
});

function initHeroSlideshow(root) {
  if (!root || root.dataset.heroReady === 'true') return;
  root.dataset.heroReady = 'true';
  const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
  if (slides.length < 2) return;
  const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
  const prev = root.querySelector('[data-hero-prev]');
  const next = root.querySelector('[data-hero-next]');
  const autoplay = root.dataset.autoplay === 'true';
  const interval = Math.max(3000, Number(root.dataset.interval) || 6000);
  const transition = Math.max(0, Number(root.dataset.transition) || 700);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
  let timer;

  slides.forEach(slide => { slide.style.transitionDuration = reduceMotion ? '0ms' : `${transition}ms`; });

  function show(index, restart = true) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const active = i === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach((dot, i) => {
      const active = i === current;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (restart) start();
  }

  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() {
    stop();
    if (autoplay && !reduceMotion && !document.hidden) timer = setInterval(() => show(current + 1, false), interval);
  }

  prev?.addEventListener('click', () => show(current - 1));
  next?.addEventListener('click', () => show(current + 1));
  dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.heroDot))));
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
  start();
}

document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);

document.addEventListener('shopify:section:load', event => {
  const root = event.target.querySelector?.('[data-hero-slideshow]') || (event.target.matches?.('[data-hero-slideshow]') ? event.target : null);
  if (root) initHeroSlideshow(root);
});

document.addEventListener('shopify:block:select', event => {
  const slide = event.target.closest?.('[data-hero-slide]');
  const root = slide?.closest('[data-hero-slideshow]');
  if (!slide || !root) return;
  const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
  slides.forEach((item, i) => {
    const active = item === slide;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-hidden', active ? 'false' : 'true');
    const dot = root.querySelector(`[data-hero-dot="${i}"]`);
    dot?.classList.toggle('is-active', active);
  });
});
